import moment from 'moment-timezone'

const serverTimeZone = 'UTC'
const pstTimeZone = 'America/Los_Angeles'

const defaultDateTimePattern = 'MM/DD/YYYY H:mm:ss'

// 将时间字符串转换为对UTC时区moment对象
function utcMoment (dateString) {
  if (!dateString || dateString === '') {
    return null
  }
  return moment.tz(dateString, serverTimeZone)
}

function utcString (dateString, pattern = defaultDateTimePattern) {
  if (!dateString || dateString === '') {
    return null
  }
  return utcMoment(dateString).format(pattern)
}

// 将时间字符串转换为对PST时区moment对象
function pstMoment (dateString) {
  if (!dateString || dateString === '') {
    return null
  }
  const utc = utcMoment(dateString)
  return utc.tz(pstTimeZone)
}

function pstString (dateString, pattern = defaultDateTimePattern) {
  if (!dateString || dateString === '') {
    return null
  }
  return pstMoment(dateString).format(pattern)
}

function localMoment (dateString) {
  if (!dateString || dateString === '') {
    return null
  }
  const utc = utcMoment(dateString)
  const localTimeZone = moment.tz.guess()
  return utc.tz(localTimeZone)
}

function localString (dateString, pattern = defaultDateTimePattern) {
  if (!dateString || dateString === '') {
    return null
  }
  return localMoment(dateString).format(pattern)
}

// 测试使用
// eslint-disable-next-line no-unused-vars
function test () {
  console.log('guess:', moment.tz.guess())
  const testString = '2021-01-05 12:03:37'
  const utc = moment.tz(testString, 'Europe/London')
  console.log('before:', utc.format('YYYY-MM-DD hh:mm:ss Z'))
  const pst = utc.clone().tz('America/Los_Angeles')
  console.log('after:', pst.format('YYYY-MM-DD hh:mm:ss Z'))
}

export default {
  utcMoment,
  utcString,
  pstMoment,
  pstString,
  localMoment,
  localString
}
